import styled from "@emotion/styled";
import { BottomNavigation, Theme } from "@mui/material";

export const StyledBottomNavigation = styled(BottomNavigation)<{theme: Theme}>((props) => ({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    '& .Mui-selected': {
        color: `${props.theme.palette.secondary.main}!important`,
    }
}))